function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _ from 'lodash';
import includes from 'lodash/includes';
var LONGHAND_BREAKS = {
  small: 'sm',
  medium: 'md',
  large: 'lg'
};
var SIZINGS_LIST = ['sn', 'sm', 'sw', 'mn', 'md', 'mw', 'ln', 'lg', 'lw'];

var _getValidIndex = function _getValidIndex(sizing) {
  var shortHandSizing = sizing; // convert start longhand to shorthand

  if (LONGHAND_BREAKS[sizing]) {
    shortHandSizing = LONGHAND_BREAKS[sizing];
  }

  var index = SIZINGS_LIST.indexOf(shortHandSizing);

  if (index < 0) {
    throw new Error("Incorrect sizing passed to classRange. Must be one of ".concat(SIZINGS_LIST.join(', ')));
  }

  return index;
};
/**
 * build a string of breakpoint sizings so you don't have to put a block of them in your code!

        'eds-l-mn-pad-2',
        'eds-l-md-pad-2',
        'eds-l-mw-pad-2',
        'eds-l-ln-pad-2',
        'eds-l-lg-pad-2',
        'eds-l-lw-pad-2',

        turns into

        classRange('pad-2', 'mn')

 * @param  {String} spacing           the class definition you wish to repeat ex: pad-hor-6, mar-right-2, mar-bot-5
 * @param  {String} startSize         starting range of class list
 * @param  {String} stopSize          optional: inclusive end of range
 * @param  {String} base              optional: class base, defaults to "eds-l"
 * @return {String}                   class list spearated by spaces, example "eds-align-"" for alignment classes
 */


export var classRange = function classRange(spacing, startSize, stopSize) {
  var base = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'eds-l';

  var startIndex = _getValidIndex(startSize);

  var endIndex = SIZINGS_LIST.length - 1;

  if (stopSize) {
    endIndex = _getValidIndex(stopSize);
  }

  if (endIndex < startIndex) {
    var temp = startIndex;
    startIndex = endIndex;
    endIndex = temp;
  }

  return SIZINGS_LIST.slice(startIndex, endIndex + 1).map(function (size) {
    return "".concat(base, "-").concat(size, "-").concat(spacing);
  }).join(' ');
};
/**
 * Filters out all key-value pairs that match the chosen value.
 *
 * @props {Object}, object - Object to be filtered
 * @props {String, Integer}, value - Value that should be filtered
 * @return {Object}, Filtered Object
 */

export var filterObjectValuesEqualTo = function filterObjectValuesEqualTo(sourceObj, targetValue) {
  return _.chain(sourceObj) // convert object into an array of [key, value] pairs
  .toPairs() // keep the pairs whose value doesn't match the target value
  .filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];

    return value !== targetValue;
  }) // convert the filtered array of pairs back into an object
  .fromPairs() // convert from lodash object to native object
  .value();
};
/**
 * Given a string, insert specific characters at specific indices.
 * @param  {string} originalString The string to transform. '4111111111111111'
 * @param  {string} insertChar     The character to insert. (For example, a space or hyphen)
 * @param  {array}  indices        A list of integers representing where the character should be inserted.
 * @return {string}                A new string with characters inserted: '4111 1111 1111 1111'
 */

export var insertCharAtIndices = function insertCharAtIndices(originalString, insertChar, indices) {
  return _toConsumableArray(originalString).reduce(function (memo, value, currentIndex) {
    memo.push(includes(indices, currentIndex) ? "".concat(insertChar).concat(value) : value);
    return memo;
  }, []).join('');
};
/**
 * @param  {string} string    A string of numbers. '41 11-1111-1111-1111 '
 * @return {string}           A new string with any spaces and hyphens removed. '4111111111111111'
 */

export var removeSpacesAndHyphens = function removeSpacesAndHyphens(string) {
  if (string) {
    return string.replace(/[\s|-]/g, '');
  }

  return string;
};